import * as React from 'react';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { DayDetailsStyle } from './DayDetails.style';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import RightIcon from "@material-ui/icons/ArrowForwardIosRounded";
import CheckIcon from '@material-ui/icons/CheckCircleRounded';
import DoneIcon from '@material-ui/icons/DoneOutlineRounded';
import NoEndTimeIcon from '@material-ui/icons/ArrowRightAlt';
import FileIcon from '@material-ui/icons/InsertDriveFileOutlined';
import { isImageFile, openFileInNewTab } from '@helpers/uploadHelper';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyMemberType } from '@services/family/family.constants';
import { IEvent } from '@app-types/websocket/event.types';
import { Link } from 'react-router-dom';
import { start } from 'repl';
import { styleColors } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof DayDetailsStyle> {
  userId:number;
  renderForDate:Date;
  event: IEvent;
  localization: "se"|"en";
  family:IFamilyMember[];
  barOneBackground?:React.CSSProperties;
  barTwoBackground?:React.CSSProperties;
  barThreeBackground?:React.CSSProperties;

  showDetails:(eventId:number|undefined) => void;
  seenEvent: (id:number) => void;
  completedBy : (eventId:number) => void;
  zoomImage: (url:string|undefined) => void;
}

interface IState {
  someValue: number;
}

class DayEvent extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      someValue: 1,
    };

  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    return;
  }

  public componentDidMount() {
    return;
  }

  public render() {
    const {classes,event,renderForDate,userId,family} = this.props;
    const background:string = this.background(event);
    const startDate = new Date(event.startTime);
    const endDate = new Date(event.endTime);
    const startToday = (startDate.getFullYear() === renderForDate.getFullYear() 
      && startDate.getMonth() === renderForDate.getMonth() 
      && startDate.getDate() === renderForDate.getDate());
    const endToday = (endDate.getFullYear() === renderForDate.getFullYear() 
      && endDate.getMonth() === renderForDate.getMonth() 
      && endDate.getDate() === renderForDate.getDate());

    const seen = (event.seen && event.seen.includes(userId));

    const thirtyDaysBack = Date.now() - (1000*60*60*24*30);
    const notSeenBy:IFamilyMember[] = [];
    if (event.seen && event.visible) {
      for (const vis of event.visible) {
        if (vis !== userId && !event.seen.includes(vis)){
          const person = family.find((mem) => mem.id === vis);
          if (person && (person.role === FamilyMemberType.PARENT || person.role === FamilyMemberType.CHILD) 
            && person.lastOnline && person.lastOnline > thirtyDaysBack) {
            notSeenBy.push(person);
          }
        }
      }
    }

    const timeData:JSX.Element = (event.checkmark
      ?(<div className={classes.eventCheckBoxPlacement}  onClick={(e) => {this.props.completedBy(event.id); e.stopPropagation();}}>
          {(event.completedBy === undefined || event.completedBy === 0)
            ?<CheckIcon style={{color:styleColors.greyLight2, paddingLeft:'10px'}}/>
            :<DoneIcon style={{color:styleColors.successGreen, paddingLeft:'10px'}}/>}
        </div>)
      :(<div className={classes.eventTimeBoxPlacement} >
          <div className={classes.eventTimeBox} >
            {(startToday
              ?(event.hasTime)
                ?(tn.formatTime(startDate))
                :tn.lang.calFullDay
              :endToday
                ?event.hasTime
                  ?<NoEndTimeIcon style={{rotate: '90deg', height: '16px', margin: '0px 4px', color:styleColors.greyMedium3}}/>
                  : " "
                :tn.lang.calFullDay)}
          </div>
          <div className={classes.eventTimeBox} style={(startToday && endToday)?{color:styleColors.greyMedium3, fontWeight: 300}:{}}>
            {endToday
              ?event.hasTime
                ?tn.formatTime(endDate)
                :startToday
                  ?" "
                  :" "
              :(startToday && event.hasTime)
                ?<NoEndTimeIcon style={{rotate: '90deg', height: '16px', margin: '0px 4px', color:styleColors.greyMedium3}}/>
                :" "}
          </div>
        </div>));

    const fileIsImage = (event.file !== undefined && isImageFile(event.file.fileName));
    const image:JSX.Element|null = ((event.file && event.file.url)
      ?(fileIsImage
        ?(<img src={event.file.url} alt={event.file.fileName} style={{height:'32px', borderRadius: '4px',
          boxShadow: '2px 2px 3px #00000075'}}/>)
        :(<a href={event.file.url} target="_blank" rel="noopener noreferrer" title={event.file.fileName}
          style={{display:'flex', color:styleColors.greyMedium3}}
          onClick={(e) => {e.preventDefault(); e.stopPropagation(); openFileInNewTab(event.file?.url);}}>
          <FileIcon style={{fontSize:'32px'}}/>
        </a>))
      :null
    );

    let titleWeight = 300;

    if (event.tagged && event.tagged.includes(userId)) {
      titleWeight = 500;
    } else if (event.tagged && event.tagged.length > 0) {
      let childEvent:undefined|boolean;
      let iAmParent = false;
      let mycolor = "";

      const me = family.find((mem) => mem.id === userId);

      if (me  && me.role === FamilyMemberType.PARENT) {
        iAmParent = true;
        mycolor = me.color;
      }

      for (const tagged of event.tagged) {
        const person = family.find((mem) => mem.id === tagged);

        if (childEvent === undefined && person && person.role === FamilyMemberType.CHILD) {
          childEvent = true;
        } else if (person && person.role === FamilyMemberType.PARENT) {
          childEvent = false;
        }
      }

      if (childEvent === true && iAmParent ) {

        const iHaveCustody = (this.props.barOneBackground && this.props.barOneBackground.backgroundColor === mycolor)
          || (this.props.barTwoBackground && this.props.barTwoBackground.backgroundColor === mycolor)
          || (this.props.barThreeBackground && this.props.barThreeBackground.backgroundColor === mycolor);
        if (iHaveCustody) { 
          titleWeight = 500;
        }
      }
    }

    return (

        <div  className={classes.event} onClick={() => {this.props.showDetails(event.id);
            if (event.seen && !event.seen.includes(userId)) {this.props.seenEvent(event.id)}}} 
          id={"eventdetails-"+event.id}>

          <div className={classes.eventScheduleData}>
            <div className={classes.eventColorBand} style={{background}}/>
            <div className={seen?classes.eventData:classes.eventDataUnseen} >
              {timeData}
              <div >
                <div className={classes.eventItemTopRow} >
                  <div className={classes.eventDescBox} style={{fontWeight: titleWeight}}>
                    {this.props.family
                    .filter((person) => (event.tagged && event.tagged.includes(person.id)))
                    .map((person, index) => <ImgAvatar altText={person.firstName} imgUrl={person.imageAvatar?person.avatarURL:undefined}
                      imgName={person.avatar} style={{width:'18px', height:'18px', marginLeft:(index>0?-8:0)}} 
                      color={person.color} key={person.id}/>)}
                    <span style={{marginLeft:(event.tagged && event.tagged.length > 0)?3:0}}>
                      {event.title}
                    </span>
                  </div>
                </div>
                {event.checkmark?<div className={classes.eventItemRow} >
                  <div className={classes.eventDescBox}>
                    <p className={classes.eventDescriptionText}>
                      {((startToday?(tn.formatTime(startDate)):"") +" - "+(endToday?tn.formatTime(endDate):""))
                      +((event.completedBy !== undefined && event.completedBy > 0)
                        ?(tn.lang.calCompletedBy(tn.familyMemberName(event.completedBy, this.props.family))):"")}
                    </p>
                  </div>
                </div>:null}

                <div className={classes.eventItemRow} >
                  <div className={classes.eventDescBox}>
                    <p className={classes.eventDescriptionText}>{event.description?this.replaceURLs(event.description):""}</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              onClick={(e) => {if (fileIsImage) {this.props.zoomImage(event?.file?.url);} e.stopPropagation();}}
              style={{marginLeft:'8px', display:((image!==null)?'flex':'none'), alignItems: 'center'}}>
              {image}
            </div>
            <div style={{marginLeft:'8px', display:(notSeenBy.length > 0?'flex':'none'), alignItems: 'center'}}>
              <div style={{display: 'flex', flexWrap: 'wrap', maxWidth: '54px', paddingLeft: '8px', paddingTop: '5px', boxSizing: 'border-box'}}>
                {notSeenBy.map((person) => <ImgAvatar altText={person.firstName} imgUrl={person.imageAvatar?person.avatarURL:undefined}
                    imgName={person.avatar} style={{width:'18px', height:'18px', marginLeft:-8, marginTop:-5}} 
                    color={person.color} key={person.id}/>)}
              </div>
            </div>
            <div style={{marginLeft:'8px', alignSelf: 'center', color: styleColors.greyMedium2, marginRight: '5px'}}>
              <RightIcon />
            </div>
          </div>
          <div className={classes.eventScheduleBands}>
            <div className={classes.eventScheduleBand} style={this.props.barTwoBackground}/>
            <div className={classes.eventScheduleBand} style={this.props.barOneBackground}/>
            <div className={classes.eventScheduleBand} style={this.props.barThreeBackground}/>
          </div>
          <div className={classes.eventLine}/>
        </div>
    );
  }

  private background(event:IEvent):string {
    let background:string = "#c3c3c3";
    const childColors:string[] = [];
    const adultColors:string[] = [];
    if (event.tagged && event.tagged.length > 0) {
      for (const tagged of event.tagged) {
        for (const mem of this.props.family) {
          if (tagged === mem.id) {
            if (mem.role === FamilyMemberType.CHILD) {
              childColors.push(mem.color);
            } else {
              adultColors.push(mem.color);
            }
          }
        }
      }
    }

    if (childColors.length > 0) {
      background = this.backgroundColor(childColors);
    } else if (adultColors.length > 0) {
      background = this.backgroundColor(adultColors);
    }
    return background
  }

  private backgroundColor(colors:string[]):string {
    if (colors.length === 0) {
      return "#c3c3c3";
    } else if (colors.length === 1) {
      return colors[0];
    } else {
      return "linear-gradient(45deg, "+colors[0]+" 0%, "+colors[1]+" 100%)";
    }
  }

  private replaceURLs(msg: string): Array<string | JSX.Element> {
    const urlRegex = new RegExp(/(https?:\/\/[^\s\,]+|www\.[^\s\,>\"]+|[^\s\,]+@[^\s\,]+)/g);
    const messageArray = msg.split(urlRegex);

    const result: Array<string | JSX.Element> = [];
    let index = 0;
    for (const msgPart of messageArray) {
      if (urlRegex.test(msgPart)) {
        let hyperLink = "";
        if (msgPart.indexOf('@') > 0) {
          hyperLink = "mailto: " + msgPart;
        } else {
          hyperLink = new RegExp('^https?:\/\/').test(msgPart) ? msgPart : `http://${msgPart}`;
        }
        if (hyperLink.startsWith('https://varannanvecka.app/app')) {
          result.push(
            <Link key={`link-${index}`} to={hyperLink.substring(25)} style={{ display: 'inline' }}>{msgPart}</Link>
          );
        }
        else {
          result.push(
            <a key={`link-${index}`} href={hyperLink} className={this.props.classes.eventDescriptionLink}
              target="_blank" rel="noopener noreferrer">
              {msgPart}
            </a>);
        }
        index++;
      } else {
        result.push(msgPart);
      }
    }

    return result;
  }
}

export default withStyles(DayDetailsStyle)(DayEvent);



// WEBPACK FOOTER //
// ./src/components/calendar2/dayDetails/DayEvent.tsx